module.exports = __webpack_public_path__ + "img/aktiv palyazatok_gomb_aktiv.869b8559.png";